import { CLEAR_REQUEST_STATUS } from 'state/requests/RequestStatusReducer';

export const SELECT_HISTORICAL_TRANSACTION_PREFIX =
  'SELECT_HISTORICAL_TRANSACTION_';
export const SELECT_HISTORICAL_TRANSACTION_PREFIX_V2 =
  'SELECT_HISTORICAL_TRANSACTION_PREFIX_V2_'
export const REQUESTED_HISTORICAL_TRANSACTIONS =
  'REQUESTED_HISTORICAL_TRANSACTIONS';
export const RECEIVED_HISTORICAL_TRANSACTIONS =
  'RECEIVED_HISTORICAL_TRANSACTIONS';
export const RECEIVED_HISTORICAL_TRANSACTIONS_V2 =
  'RECEIVED_HISTORICAL_TRANSACTIONS_V2';
export const ERROR_HISTORICAL_TRANSACTIONS = 'ERROR_HISTORICAL_TRANSACTIONS';
export const ERROR_PENDING_TRANSACTIONS = 'ERROR_PENDING_TRANSACTIONS';
export const RECEIVED_PENDING_TRANSACTIONS = 'RECEIVED_PENDING_TRANSACTIONS';
export const RECEIVED_PENDING_TRANSACTIONS_V2 = 'RECEIVED_PENDING_TRANSACTIONS_V2';

export const REQUESTED_PENDING_TRANSACTIONS = 'REQUESTED_PENDING_TRANSACTIONS';
export const SELECT_HISTORICAL_TRANSACTION_TIME_PERIOD =
  SELECT_HISTORICAL_TRANSACTION_PREFIX + 'TIME_PERIOD';
export const SELECT_HISTORICAL_TRANSACTION_INCLUDED_ACCOUNTS =
  SELECT_HISTORICAL_TRANSACTION_PREFIX + 'INCLUDED_ACCOUNTS';
export const SELECT_HISTORICAL_TRANSACTION_TRANSACTION_TYPE =
  SELECT_HISTORICAL_TRANSACTION_PREFIX + 'TRANSACTION_TYPE';
export const SELECT_HISTORICAL_TRANSACTION_DATE_OPTIONS =
  SELECT_HISTORICAL_TRANSACTION_PREFIX + 'DATE_OPTIONS';
export const SELECT_HISTORICAL_TRANSACTION_TIME_PERIOD_V2 =
  SELECT_HISTORICAL_TRANSACTION_PREFIX_V2 + 'TIME_PERIOD';
export const SELECT_HISTORICAL_TRANSACTION_INCLUDED_ACCOUNTS_V2 =
  SELECT_HISTORICAL_TRANSACTION_PREFIX_V2 + 'INCLUDED_ACCOUNTS';
export const SELECT_HISTORICAL_TRANSACTION_TRANSACTION_TYPE_V2 =
  SELECT_HISTORICAL_TRANSACTION_PREFIX_V2 + 'TRANSACTION_TYPE';
export const UPDATE_HISTORICAL_TRANSACTION_ACCORDION_ARRAY =
  'UPDATE_HISTORICAL_TRANSACTION_ACCORDION_ARRAY';
export const TIME_PERIOD = 'timePeriod';
export const DATE_OPTIONS = 'dateOptions';
export const INCLUDED_ACCOUNTS = 'includedAccounts';
export const TRANSACTION_TYPE = 'transactionType';
export const REQUESTED_PRIOR_BUSINESS_DATE = 'REQUESTED_PRIOR_BUSINESS_DATE';
export const RECEIVED_PRIOR_BUSINESS_DATE = 'RECEIVED_PRIOR_BUSINESS_DATE';
export const ERROR_PRIOR_BUSINESS_DAY = 'ERROR_PRIOR_BUSINESS_DAY';
export const REQUESTED_CANCEL_PENDING_TRANSACTION =
  'REQUESTED_CANCEL_PENDING_TRANSACTION';
export const RECEIVED_CANCEL_PENDING_TRANSACTION =
  'RECEIVED_CANCEL_PENDING_TRANSACTION';
export const ERROR_CANCEL_PENDING_TRANSACTION =
  'ERROR_CANCEL_PENDING_TRANSACTION';

export const requestedHistoricalTransactions = () => ({
  type: REQUESTED_HISTORICAL_TRANSACTIONS
});

export const receivedHistoricalTransactions = (transactions) => ({
  type: RECEIVED_HISTORICAL_TRANSACTIONS,
  transactions
});

export const receivedHistoricalTransactionsV2 = (transactions) => ({
  type: RECEIVED_HISTORICAL_TRANSACTIONS_V2,
  transactions
});

export const errorHistoricalTransactions = (error) => ({
  type: ERROR_HISTORICAL_TRANSACTIONS,
  error
});

export const errorPendingTransactions = (error) => ({
  type: ERROR_PENDING_TRANSACTIONS,
  error
});

export const receivedPendingTransactions = (transactions) => ({
  type: RECEIVED_PENDING_TRANSACTIONS,
  transactions
});

export const receivedPendingTransactionsV2 = (transactions) => ({
  type: RECEIVED_PENDING_TRANSACTIONS_V2,
  transactions
});

export const requestedPendingTransactions = () => ({
  type: REQUESTED_PENDING_TRANSACTIONS
});

export const selectHistoricalTransactionTimePeriod = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_TIME_PERIOD,
  selection
});

export const selectHistoricalTransactionIncludedAccounts = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_INCLUDED_ACCOUNTS,
  selection
});

export const selectHistoricalTransactionTransactionType = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_TRANSACTION_TYPE,
  selection
});

export const selectHistoricalTransactionDateOptions = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_DATE_OPTIONS,
  selection
});

export const selectHistoricalTransactionTimePeriodV2 = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_TIME_PERIOD_V2,
  selection
});

export const selectHistoricalTransactionIncludedAccountsV2 = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_INCLUDED_ACCOUNTS_V2,
  selection
});

export const selectHistoricalTransactionTransactionTypeV2 = (selection) => ({
  type: SELECT_HISTORICAL_TRANSACTION_TRANSACTION_TYPE_V2,
  selection
});

export const updateHistoricalTransactionAccordionArray = (uniqueId) => ({
  type: UPDATE_HISTORICAL_TRANSACTION_ACCORDION_ARRAY,
  uniqueId
});

export const requestedPriorBusinessDate = () => ({
  type: REQUESTED_PRIOR_BUSINESS_DATE
});

export const receivedPriorBusinessDay = (priorBusinessDay) => ({
  type: RECEIVED_PRIOR_BUSINESS_DATE,
  priorBusinessDay
});

export const errorPriorBusinessDay = () => ({
  type: ERROR_PRIOR_BUSINESS_DAY
});

export const requestedCancelPendingTransaction = () => ({
  type: REQUESTED_CANCEL_PENDING_TRANSACTION
});

export const receivedCancelPendingTransaction = () => ({
  type: RECEIVED_CANCEL_PENDING_TRANSACTION
});

export const errorCancelPendingTransaction = (error) => ({
  type: ERROR_CANCEL_PENDING_TRANSACTION,
  error
});

export const clearCancelPendingTransaction = () => ({
  type: CLEAR_REQUEST_STATUS,
  payload: {
    requestStatus: 'cancelPendingTransaction'
  }
});
